import { Fragment } from "react";

export default function Marquee({ items, testId = "editorial-marquee" }) {
  const group = (hidden) => (
    <div className="flex items-center" aria-hidden={hidden ? "true" : undefined}>
      {items.map((item, i) => (
        <Fragment key={`${item}-${i}`}>
          <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wide text-white/85 md:text-4xl">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-[#e6b800]" aria-hidden="true" />
        </Fragment>
      ))}
    </div>
  );

  return (
    <div
      className="marquee relative overflow-hidden border-y border-white/10 bg-[#0a0a0e] py-6"
      data-testid={testId}
    >
      <div className="marquee-track">
        {group(false)}
        {group(true)}
      </div>
    </div>
  );
}